<div cdkTrapFocus
     role="dialog"
     [attr.aria-modal]="true"
     [attr.aria-labelledby]="_dialogLabelId ?? undefined"
     [attr.mode]="datetimepicker.mode"
     class="mtx-datetimepicker-content-container"
     [class.mtx-datetimepicker-content-container-with-custom-header]="datetimepicker.calendarHeaderComponent"
     [class.mtx-datetimepicker-content-container-with-actions]="_actionsPortal"
     [class.mtx-datetimepicker-content-container-with-time-input]="datetimepicker.timeInput">
  <mtx-calendar [id]="datetimepicker.id"
                [class]="datetimepicker.panelClass"
                [attr.mode]="datetimepicker.mode"
                [type]="datetimepicker.type"
                [startAt]="datetimepicker.startAt"
                [startView]="datetimepicker.startView"
                [maxDate]="datetimepicker._maxDate"
                [minDate]="datetimepicker._minDate"
                [dateFilter]="datetimepicker._dateFilter"
                [multiYearSelector]="datetimepicker.multiYearSelector"
                [preventSameDateTimeSelection]="datetimepicker.preventSameDateTimeSelection"
                [headerComponent]="datetimepicker.calendarHeaderComponent"
                [timeInterval]="datetimepicker.timeInterval"
                [twelvehour]="datetimepicker.twelvehour"
                [selected]="datetimepicker._selected"
                [timeInput]="datetimepicker.timeInput"
                [actionsPortal]="_actionsPortal"
                [timeInputAutoFocus]="datetimepicker.timeInputAutoFocus"
                (selectedChange)="datetimepicker._select($event)"
                (viewChanged)="datetimepicker._viewChanged($event)"
                (viewChanged)="_viewChanged($event)"
                (_userSelection)="_handleUserSelection()"
                [@fadeInCalendar]="'enter'">
  </mtx-calendar>

  <ng-template [cdkPortalOutlet]="_actionsPortal"></ng-template>
</div>
